import isdlAccessInstance from './isdlAccessInstance';
import { ConvertSubCategoryToPCCategory } from '../productData/clubData';
//GET

//getAllTaskIDsForHeadID
export const getAllTaskIDsForHeadID = async (headId) => await isdlAccessInstance.taskmanData.GetAllTaskIDsForHeadID(headId);

//GetTaskInfo
export const getTaskInfo = async (taskId) => await isdlAccessInstance.taskmanData.GetTaskInfo(taskId);

export const getTaskStatus = async (taskId) => await isdlAccessInstance.taskmanData.GetTaskStatus(taskId);

//POST

//UTILS
export function getValidHeadSN(item, nullValue = "N/A"){
  let returnVal = "";

  if(typeof item.head_sn_label === "string"){
      returnVal = item.head_sn_label;
  }else{
      if(typeof item.base_sn_label === "string"){
      returnVal = item.base_sn_label;
      }else{
          returnVal = nullValue;
      }
  }

  return returnVal;
}

export function getLoft(item){

    if(item.base_comp_type && item.base_comp_type === "Ball"){
        return "--";
    }

    if(item.base_comp_type && item.base_comp_type === "Shaft"){
        return "--";
    }

  const PCCat = ConvertSubCategoryToPCCategory(item.category);

  let returnVal = "";

  switch(PCCat){
      case "1":
          if (typeof item.stated_loft === "string") {
              returnVal = item.stated_loft.toString();
          } else if (typeof item.loft_id === "string") {
              returnVal = item.loft_id.toString();
          } else if (typeof item.loft_meas === "number") {
              returnVal = item.loft_meas.toString();
          } else {
              returnVal = "No loft value";
          }
          break;
      default:
          if (typeof item.loft_id === "string") {
              returnVal = item.loft_id.toString();
          } else if (typeof item.loft_meas === "number") {
              returnVal = item.loft_meas.toString();
          } else if (typeof item.stated_loft === "string") {
              returnVal = item.stated_loft.toString();
          } else {
              returnVal = "No loft value";
          }
          break;
  }

  return returnVal;
}

export function getComponentType(item){
  let returnVal = "Club";

  switch(item.base_comp_type){
      case "Club":
      case "Head":
          returnVal = "Club";
          break;
      case "Ball":
          returnVal = "Ball";
          break;
      case "Shaft":
        returnVal = "Shaft";
        break;
      default:
          break;
  }

  return returnVal;// item.base_comp_type;
}

export function getValidComponentHeader(item){
    if(item.base_comp_type && item.base_comp_type === "Ball"){
        return item.group_num;
    }else{
        return getValidBaseSN(item);
    }
}

export function getValidBaseSN(item, nullValue = "N/A"){
  let returnVal = "";

  if(typeof item.base_sn_label === "string"){
      returnVal = item.base_sn_label;
  }else{
      returnVal = nullValue;
  }

  return returnVal;
}

export function getValidShaftSN(item, nullValue = "N/A"){
  let returnVal = "";

  if(typeof item.shaft_sn_label === "string"){
      returnVal = item.shaft_sn_label;
  }else{
      returnVal = nullValue;
  }

  return returnVal;
}

export function getValidMeasuredData(item, type, nullValue = "N/A"){
  let returnVal = "";

  if(typeof item === type){
      returnVal = item;
  }else{
      returnVal = nullValue;
  }

  return returnVal;
}
